//nlp for hermes
export const generate_nlp_response_param = (
  user_query,
  message_uuid,
  session_id,
  firstName,
  lastName,
  token,
  username
) => {
  return {
    MESSAGE: {
      QUERY: user_query,
      QUERY_UUID: message_uuid,
      SESSION_ID: session_id,
      USER_NAME: (firstName + lastName).toLowerCase().trim(),
      USER_ID: username,
    },
    TOKEN: token,
    USERID: username,
  };
};

//nlp for adya
export const generate_adya_nlp_response_param = (
  user_language,
  user_query,
  user_query_id,
  session_id,
  channel,
  query_request_timestamp
) => {
  return {
    CHANNEL: channel,
    MESSAGE: {
      USER_LANGUAGE: user_language,
      QUERY: user_query,
      QUERY_ID: user_query_id,
      SESSION_ID: session_id,
    },
    REQUEST_TIMESTAMP: query_request_timestamp,
  };
};

// Quick Menu
export const generate_Quick_Menu_response_param = (id, lang, session_id,font) => {
  
  return {
    MESSAGE: {
      TARGETID: id,
      NAME: null,
      TARGET: "quickmenu",
      LANG: lang,
      SESSION_ID: session_id,
      font:font
    },
  };
};

// Floating Menu
export const generate_floatingMenu_response_param = (id, lang, session_id) => {
  //session_id
  return {
    MESSAGE: {
      TARGETID: id,
      NAME: null,
      TARGET: "menu",
      LANG: lang,
      SESSION_ID: session_id,
    },
  };
};

// Guided Menu
export const generate_guidedMenu_response_param = (
  id,
  user_query,
  target,
  lang,
  session_id
) => {
  return {
    MESSAGE: {
      TARGETID: id,
      QUERY: user_query,
      TARGET: target,
      LANG: lang,
      SESSION_ID: session_id,
      CHILD_NODE:true
    },
  };
};

// FAQ Menu Handler
export const generate_faqMenu_response_param = (
  id,
  user_query,
  target,
  lang,
  session_id
) => {
  debugger
  return {
    MESSAGE: {
      TARGETID: id,
      QUERY: user_query,
      TARGET: target,
      LANG: lang,
      SESSION_ID: session_id,
    },
  };
};

// Account Balance Workflow (testing)
export const generate_triggerWorkflow_response_param = (
  id,
  user_query,
  target,
  channel,
  session_id,
  workflow_activity_id,
  workflow_start_timestamp,
  language
) => {
  return {
    MESSAGE: {
      TARGETID: id,
      QUERY: user_query,
      TARGET: target,
      CHANNEL: channel,
      SESSION_ID: session_id,
      WORKFLOW_ACTIVITY_ID: workflow_activity_id,
      WORKFLOW_START_TIMESTAMP: workflow_start_timestamp,
      LANGUAGE: language,
    },
  };
};

// id, user_query, target => if needed later
// export const generate_workflow_data_response_param = (
//   user_query,
//   session_id,
//   workflow_activity_id,
//   RbiPrompt
// ) => {
//   const starting = formatDate(`${user_query.startDate}`);
//   const ending = formatDate(`${user_query.endDate}`);

//   function formatDate(input) {
//     const year = input.substring(4);
//     const month = input.substring(2, 4);
//     const day = input.substring(0, 2);

//     const formattedDate = `${day}/${month}/${year}`;

//     return formattedDate;
//   }
//   return {
//     MESSAGE: {
//       // QUERY: `${user_query.startDate}-${user_query.endDate}`,
//       QUERY:
//         RbiPrompt === "Dr"
//           ? `{\"startDate\": \"${starting}\",\"endDate\": \"${ending}\"}`
//           : `{\"startDate\": \"${user_query}\",\"endDate\": \"${user_query}\"}`,
//       //original
//       // QUERY: Dr === "Dr" ? `${starting}-${ending}` : user_query,
//       SESSION_ID: session_id,
//       WORKFLOW_ACTIVITY_ID: workflow_activity_id,
//       // TARGETID: id,
//       // TARGET: target,
//     },
//   };
// };
export const generate_workflow_data_response_param = (

  user_query,
  session_id,
  workflow_activity_id,
  RbiPrompt
) => {
  debugger
  const starting = formatDate(`${user_query.startDate}`);
  const ending = formatDate(`${user_query.endDate}`);

  function formatDate(input) {
    const year = input.substring(4);
    const month = input.substring(2, 4);
    const day = input.substring(0, 2);

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  }

  let query;
  if (RbiPrompt === "Dr") {
    query = `{\"startDate\": \"${starting}\",\"endDate\": \"${ending}\"}`;
  } else if (RbiPrompt === "Dp") {
    query = `{\"startDate\": \"${user_query}\",\"endDate\": \"${user_query}\"}`;
  } else {
    query = user_query;
  }

  return {
    MESSAGE: {
      QUERY: query,
      SESSION_ID: session_id,
      WORKFLOW_ACTIVITY_ID: workflow_activity_id,
    },
  };
};

export const generate_workflow_user_select_yesorno_param = (
  user_choice,
  session_id,
  workflow_activity_id,
  workflow_end_timestamp
) => {
  return {
    MESSAGE: {
      USER_CHOICE: user_choice,
      SESSION_ID: session_id,
      WORKFLOW_ACTIVITY_ID: workflow_activity_id,
      WORKFLOW_END_TIMESTAMP: workflow_end_timestamp,
      // TARGETID: id,
      // TARGET: target,
    },
  };
};

// export const generate_SCP_WORKFLOW_data_params = (user_data) => {
  
//   return {
//     MESSAGE: {
//       SESSON_ID :sessionStorage.getItem("sessionId"),
//       CONVERSATION_ID: sessionStorage.getItem("conversation_id"),
//       DATA: user_data
//     }
//   }
// }
